import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21 5.75C21.2652 5.75011 21.5205 5.85545 21.708 6.04297C21.8952 6.23044 22.0009 6.48506 22.001 6.75C22.0009 7.01517 21.8955 7.27049 21.708 7.45801L9.70801 19.458C9.6153 19.5508 9.50492 19.6245 9.38379 19.6748C9.26252 19.7251 9.13127 19.7509 9 19.751C8.86891 19.7509 8.73831 19.7249 8.61719 19.6748C8.52646 19.6372 8.44189 19.5855 8.36621 19.5234L8.29297 19.458L3.04297 14.208C2.85545 14.0205 2.75011 13.7652 2.75 13.5C2.75011 13.2348 2.85545 12.9805 3.04297 12.793C3.23048 12.6055 3.48482 12.5001 3.75 12.5C4.01517 12.5001 4.27049 12.6055 4.45801 12.793L9 17.3359L20.293 6.04297C20.4805 5.85545 20.7348 5.75011 21 5.75Z",
		fill: "currentColor"
	})
});
export default SvgCheck;
